import React, { useEffect, useState,useRef } from 'react';
import { Link } from 'react-router-dom';
import { rootRoute } from '../../../config';
import { motion } from "framer-motion";
import { play_simulation, save_userData } from '../services/api';
import { errorMsg } from '../../../helper/helpers';
import Button from '../../common/Button';
import SimProgress from './SimProgress';
import CalProfitLoss from './CalProfitLoss';
import RevenueGraph from './RevenueGraph';
import InventoryGraph from './InventoryGraph';
import { useOutletContext } from "react-router-dom";
import QmModuleStyle from '../styles/qm.module.css';
import info from '../assets/info.png';
import ReactDOM from 'react-dom';
import GraphDataTable from './GraphDataTable';
import MakeDecisions from './MakeDecisions';

const Simulation = () => {
  const [quantity, setQuantity] = useState(50);
  const [shippingType, setShippingType] = useState("NORMAL_SHIPPING");
  const [simPopup, setSimPopup, isOverlay, setIsOverlay, headerPopup, setHeaderPopup, isArtifacts, setIsArtifacts, plPopup, setPlPopup, ulPopup, setUlPopup, simPrgPopup, setSimPrgPopup, skipWalkThruPopups, isPopupShown, setIsPopupShown, accordionPopup, setAccordionPopup, simObj, setSimObj, getMonth, toggleSimulation, setToggleSimulation, startOverSimulation, isLoader, setIsLoader, setAriaProperty, check_Location, setError, error, simType, qmPopup, setQmPopup,setRelaunchPopup,focusPopUp,isModalVisible,setIsModalVisible] = useOutletContext();
  const [isDecisionPopup, setIsDecisionPopup] = useState(false);
  const [isShowPlaceOrder, setIsShowPlaceOrder] = useState(false);
  const [isRequestLoading, setIsRequestLoading] = useState(false);
  const [point, setPoint] = useState(null);
  const [pOrderActivityHeight, setPOrderActivityHeight] = useState(0);
  const [userDataInfo, setUserDataInfo] = useState(false);
  const [qmKpiTop, setQmKpiTop] = useState(0);
  const [availCashTop, setAvailCashTop] = useState(0);
  const [utilizeBtnTop, setUtilizeBtnTop] = useState(0);
  const [utilizedInvestTop, setUtilizedInvestTop] = useState(0);
  const isUserInput = useRef(false);
  const [inputValue, setInputValue] = useState("");
  const [isStyleTagPresent, setIsStyleTagPresent] = useState(false); //Added for stylus tool text-spacing change
  const checkUserInput = (event)=> {
  const regex = /^[a-zA-Z.&-']*$/;
        
    // Allowed for Special Char
    if (false && !regex.test(event.target.value)) {
        setUserDataInfo({"valid":0,"message":"Special characters allowed & - ' ."})
        document.querySelector(".user-input .btn_approve").style.pointerEvents = "none"
        document.querySelector(".user-input .btn_approve").style.opacity = "0.6"
    }
    else{
      setUserDataInfo(false);
      document.querySelector(".user-input .btn_approve").style.pointerEvents = "auto"
      document.querySelector(".user-input .btn_approve").style.opacity = "1"
    }
  }
  const inValidInputStyle = {
    color: 'rgb(185, 0, 0)'
  }
  const showDecisionPopup = () => {
    setIsDecisionPopup(true);
  }
  const hideDecisionPopup = () => {
    setIsDecisionPopup(false);
    var element = document.getElementById('RevenueGraph-Quality');
    element.style.overflow = 'hidden';
  }
  const saveUserData = (a)=> {
    let userData = a=="save" ? document.getElementById("userData").value : "Cibare";
    save_userData({
      "id":simObj?.id,
      "executioninstanceid": simObj?.executioninstanceid,
      "attemptno": simObj?.attemptno,
      "userData": userData
    }).then((response)=>{
      if (response.status === 500 && response?.data?.hasOwnProperty("id") && response?.data?.hasOwnProperty("msg")) {
        setError(response?.data)
      }
    else{
      if (typeof response != 'undefined') {
        if(response?.data?.valid){
          let newSimObj = {
            ...response?.data, actions:
              response?.data.actions?.map((action) => ({
                ...action,
                type: "PlaceOrder",
                quantity: !(quantity) ? 50 : quantity,
                shippingType: shippingType
              }))
          }
          setSimObj(newSimObj);
          // window.$('.ui.tiny.modal.user-input').modal('hide');
          setIsModalVisible(false);
          window.$('.my-dimmer .ui.dimmer').dimmer("hide");
        }
        else{
          setUserDataInfo(response?.data)
        }  
      }
    }
    }).catch(()=>{
      // setError(errorMsg);
      setError({"id":"00000","msg":errorMsg})
    })
  }
  const loadNextPoup = () => {
    setSimPopup(false);
    setIsOverlay(false);
    setIsPopupShown(true);
    if (document.querySelector(".help-link") != null) {
      document.querySelector(".help-link").focus();
    }
  }


  const playSimulation = () => {
    setTimeout(() => {
    setToggleSimulation(true);
    }, 0);
    /*
    var profitLossElements = document.getElementsByClassName("profit-loss");
    var currentdaysElements = document.getElementsByClassName("currentdays");
    for (var i = 0; i < profitLossElements.length; i++) {
        profitLossElements[i].setAttribute("role", "alert");
    }
    for (var i = 0; i < currentdaysElements.length; i++) {
      currentdaysElements[i].setAttribute("role", "alert");
    }
    */
  }

  const resumeSimulation = () => {
    let runSimObj = {}
    for (let key in simObj) {
      if (!window.$.isArray(simObj[key])) {
        runSimObj[key] = simObj[key]
      }
    }
    if (!isRequestLoading) {
      setIsRequestLoading(true);
      play_simulation(simObj.sessionid, runSimObj).then((response) => {
        if (response.status === 500 && response?.data?.hasOwnProperty("id") && response?.data?.hasOwnProperty("msg")) {
          setError(response?.data)
      }
      else{
        if (typeof response != 'undefined') {
          let newSimObj = {
            ...response?.data, actions:
              response?.data.actions?.map((action) => ({
                ...action,
                type: "PlaceOrder",
                quantity: !(quantity) ? 50 : quantity,
                shippingType: shippingType
              }))
          }
          setSimObj(newSimObj);
          setIsShowPlaceOrder(false);
          setIsRequestLoading(false);
        }
      }
      }).catch((error) => {
        // setError(errorMsg);
        setError({"id":"00000","msg":errorMsg})
        console.log(error);
      })
    }
  }

  const pauseSimulation = () => {
    setToggleSimulation(false);
    /*
    var profitLossElements = document.getElementsByClassName("profit-loss");
    var currentdaysElements = document.getElementsByClassName("currentdays");
    for (var i = 0; i < profitLossElements.length; i++) {
      profitLossElements[i].removeAttribute("role");
    }
    for (var i = 0; i < currentdaysElements.length; i++) {
      currentdaysElements[i].removeAttribute("role");
    }
    console.log("pasuse:" + simObj.currentstep)
    */
  }
  const fuSkipWalkThruPopups = () => {
    let readStatusLength = simObj?.artifacts?.filter((artifact) => artifact.readstatus == 1).length;
    console.log("readcount:" + readStatusLength)
    if (simObj?.currentstep > 0 || simObj?.attemptno > 1 || readStatusLength > 0 || simObj?.decisionHistory != null || simObj?.decisionHistory?.length != undefined) {
      skipWalkThruPopups(false);
    }
  }
  const initSimulation = () => {
    if (!isPopupShown) {
      setIsOverlay(true);
      setHeaderPopup(true)
    }
    setIsArtifacts(true);
  }
  useEffect(() => {
    initSimulation();
    window.$('.ui.accordion').accordion();
    window.$('html, body').animate({
      scrollTop: 0
    }, 100);
    // document.querySelector("footer.footer .footer-nav .footer-links li.skip-intro").style.display = "none";
    document.title = "Quality Management | Simulation";
    document.querySelector("header.header h1.title").focus();
    document.querySelector(".skip-to-main-content-link").style.display = "block";
    if (document.querySelector("#showSummary")) {
      document.querySelector("#showSummary").focus();
    }
    return () => {
      document.querySelector(".skip-to-main-content-link").style.display = "none";
    }
  }, []);

  const [periodicalType, setPeriodicalType] = useState("monthly");
  const funMonthlyHandler = (e) => {
    setPeriodicalType("monthly");
    setIsDecisionPopup(false);
  }
  const funQuarterlyHandler = (e) => {
    setPeriodicalType("quarterly");
    setIsDecisionPopup(false);
  }
  const funYearlyHandler = (e) => {
    setPeriodicalType("yearly");
    setIsDecisionPopup(false);
  }
  const [periodicalTypeFailure, setPeriodicalTypeFailure] = useState("monthly");
  const funMonthlyHandlerFailure = (e) => {
    setPeriodicalTypeFailure("monthly");
  }
  const funQuarterlyHandlerFailure = (e) => {
    setPeriodicalTypeFailure("quarterly");
  }
  const funYearlyHandlerFailure = (e) => {
    setPeriodicalTypeFailure("yearly");
  }
  const formatNum = (num) => {
    return num?.toLocaleString('en-US', { style: 'decimal' });
  }
  useEffect(() => {
    fuSkipWalkThruPopups();
    console.log(simObj)
  }, [simObj])

  const functionTabGraphControl =()=>{
    class TabsManual {
      constructor(groupNode) {
        this.tablistNode = groupNode;

        this.tabs = [];

        this.firstTab = null;
        this.lastTab = null;

        this.tabs = Array.from(this.tablistNode.querySelectorAll('[role=tab]'));
        this.tabpanels = [];

        for (var i = 0; i < this.tabs.length; i += 1) {
          var tab = this.tabs[i];
          var tabpanel = document.getElementById(tab.getAttribute('aria-controls'));

          tab.tabIndex = -1;
          tab.setAttribute('aria-selected', 'false');
          this.tabpanels.push(tabpanel);

          tab.addEventListener('keydown', this.onKeydown.bind(this));
          tab.addEventListener('click', this.onClick.bind(this));

          if (!this.firstTab) {
            this.firstTab = tab;
          }
          this.lastTab = tab;
        }

        this.setSelectedTab(this.firstTab);
      }

      setSelectedTab(currentTab) {
        for (var i = 0; i < this.tabs.length; i += 1) {
          var tab = this.tabs[i];
          if (currentTab === tab) {
            tab.setAttribute('aria-selected', 'true');
            tab.removeAttribute('tabindex');
            //this.tabpanels[i].classList.remove('is-hidden');
          } else {
            tab.setAttribute('aria-selected', 'false');
            tab.tabIndex = -1;
            //this.tabpanels[i].classList.add('is-hidden');
          }
        }
      }

      moveFocusToTab(currentTab) {
        currentTab.focus();
      }

      moveFocusToPreviousTab(currentTab) {
        var index;

        if (currentTab === this.firstTab) {
          this.moveFocusToTab(this.lastTab);
        } else {
          index = this.tabs.indexOf(currentTab);
          this.moveFocusToTab(this.tabs[index - 1]);
        }
      }

      moveFocusToNextTab(currentTab) {
        var index;

        if (currentTab === this.lastTab) {
          this.moveFocusToTab(this.firstTab);
        } else {
          index = this.tabs.indexOf(currentTab);
          this.moveFocusToTab(this.tabs[index + 1]);
        }
      }

      /* EVENT HANDLERS */

      onKeydown(event) {
        var tgt = event.currentTarget,
          flag = false;

        switch (event.key) {
          case 'ArrowLeft':
            this.moveFocusToPreviousTab(tgt);
            flag = true;
            break;

          case 'ArrowRight':
            this.moveFocusToNextTab(tgt);
            flag = true;
            break;

          case 'Home':
            this.moveFocusToTab(this.firstTab);
            flag = true;
            break;

          case 'End':
            this.moveFocusToTab(this.lastTab);
            flag = true;
            break;

          default:
            break;
        }

        if (flag) {
          event.stopPropagation();
          event.preventDefault();
        }
      }

      // Since this example uses buttons for the tabs, the click onr also is activated
      // with the space and enter keys
      onClick(event) {
        this.setSelectedTab(event.currentTarget);
      }
    }
    // window.addEventListener('load', function () {
    //   var tablists = document.querySelectorAll('[role=tablist].Graphs');
    //   for (var i = 0; i < tablists.length; i++) {
    //     new TabsManual(tablists[i]);
    //   }
    //   if(document.querySelectorAll('.Graphs button') != null){
    //     const elementsWithClassGraphs = document.querySelectorAll('.Graphs button');
    //     elementsWithClassGraphs.forEach(element => {
    //         if (element.getAttribute('aria-selected') === 'false') {
    //             element.setAttribute('tabindex', '-1');
    //         }
    //     });
    //   }
    // });
    const initTabs = ()=>{
      var tablists = document.querySelectorAll('[role=tablist].Graphs');
      for (var i = 0; i < tablists.length; i++) {
        new TabsManual(tablists[i]);
      }
      if(document.querySelectorAll('.Graphs button') != null){
        const elementsWithClassGraphs = document.querySelectorAll('.Graphs button');
        elementsWithClassGraphs.forEach(element => {
            if (element.getAttribute('aria-selected') === 'false') {
                element.setAttribute('tabindex', '-1');
            }
        });
      }
    }
    initTabs()
  }
  useEffect(() => {
    functionTabGraphControl();
  }, [])

  const openNewWindow = (data) => {
    const newWindow = window.open('', '_blank', 'width=800,height=800');
    if (newWindow) {
      newWindow.document.open();
      const htmlContentWithNbsp = `
<!DOCTYPE html>
<html>
<head>
    <title>Quality Management</title>
    <link rel="stylesheet" type="text/css" href="https://cdn.datatables.net/1.13.6/css/jquery.dataTables.min.css">
    <style>
          .MainDiv {
              min-height: 620px;
              overflow: hidden;
              width: 95%;
              margin: 0 auto;
          }
          .MainDivChild {
              overflow-x: auto;
              margin: 10px auto;
          }
          table.dataTable thead th {
            border: 1px solid rgba(0, 0, 0, 0.3);
            background-color: #f0f0f0;
          }
          .dataTables_length {
              min-width: 5.5em;
              padding: 10px;
          }
          .dataTables_filter {
            min-width: 5.5em;
            padding: 10px;
            text-align: left;
          }
          .table {
              width: 100%;
              max-width: 100%;
              margin-bottom: 20px;
          }
          .headingh3 {
              color: #002D5F;
              font-weight: 700;
              font-size: 22px;
              background: transparent;
              padding: 0;
          }
          header.header {
            box-shadow: 0px 1px 2px 0px #CCCCCC;
            color: #012F61;
            position: relative;
          }
          header.header>.container {
            margin: 0px 20px;
            display: flex;
            justify-content: space-between;
            min-height: 60px;
            align-items: center;
          }
          header.header>.container h1 {
            display: flex;
            justify-content: center;
            align-items: center;
            color: #b2347b;
          }
          table.dataTable thead th {
              color: #002D5F;
          }
          .header-container header {
          font-size: 12px;
          color: #b2347b;
          }
          .footer {
              background-color: #CDCDCD;
              font-size: 12px;
              padding: 6px;
              text-align: center;
              color: #000000;
          }
          .footer .container {
              display: flex;
              align-items: center;
              justify-content: center;
              width: 82.5%;
              margin: auto;
          }
          .footer .container>div {
              display: flex;
          }
          .footer-links {
              list-style-type: none;
              padding-left: 0;
              padding: 0 5px;
              margin: 0;
              display: flex;
          }
          .footer-links .listitem a {
              text-decoration: underline;
              color: #000000;
          }
          #RevenueGraphData th {
            padding: 4px; 
          }
          #RevenueGraphData tr td:first-child {
            width: 45px; 
          }
    </style>
</head>
<body style="font: 16px/26px 'Roboto', 'Helvetica Neue', Helvetica, Arial; -webkit-font-smoothing: antialiased; font-weight: 300;margin:0;">
<div id="new-component-root"></div>
<script src="https://cdnjs.cloudflare.com/ajax/libs/jquery/3.6.0/jquery.min.js"></script>
<script src="https://cdn.datatables.net/1.13.6/js/jquery.dataTables.min.js"></script>
<script>
    document.addEventListener('DOMContentLoaded', function() {
        $('#RevenueGraphData').DataTable({
            pagingType: 'full_numbers'
        });
        $('#FailureGraphData').DataTable({
            pagingType: 'full_numbers'
        });
    });
</script>
</body>
</html>
`;
      const htmlContentWithoutNbsp = htmlContentWithNbsp.replace(/&nbsp;/g, ' ');


      newWindow.document.write(htmlContentWithoutNbsp);
      ReactDOM.render(<GraphDataTable type={periodicalType} simObj={simObj} setSimObj={setSimObj} />, newWindow.document.getElementById("new-component-root"));
      newWindow.document.close();
    }
  };

  // Reset the user input field to the default placeholder
  function resetUserDataInput() {
    window.$('.user-data-input').val(''); // Clear the input field
    window.$('.user-data-input').attr('placeholder', 'Cibare'); // Reset placeholder
  }
  // Listen for the custom event to reset the input
  document.addEventListener('resetUserDataInput', resetUserDataInput);

  window.$(document).off('keyup keydown', '.user-input #userData').on('keyup keydown','.user-input #userData', function(e) {
    checkUserInput(e);
  });
  window.$(document).off('click touchstart', '.custom-modal .ui.btn_cancel.button').on('click touchstart','.custom-modal .ui.btn_cancel.button', function(e) {
    e.stopPropagation();
    saveUserData("skip");
  });
  window.$(document).off('click touchstart', '.custom-modal .ui.btn_approve.button').on('click touchstart','.custom-modal .ui.btn_approve.button', function(e) {
    e.stopPropagation();
    saveUserData("save");
  });
  // useEffect(() => {
  //   if((simObj?.hasOwnProperty("userData") && simObj?.userData == "") && (simObj?.hasOwnProperty("version") && simObj?.version > 1)){
  //     if(window.$(".ui.dimmer .user-input").length >1){
  //       window.$(".ui.dimmer .user-input:last").remove();
  //     }
  //     window.$('.ui.tiny.modal.user-input').modal({
  //       closable: false // Prevents closing on click outside
  //     }).modal('show');
  //     isUserInput.current = true;
  //     // setIsUserInputPopup(false);
  //   }
  // },[simObj])

  // useEffect(()=>{
  //   if(simObj?.hasOwnProperty("userData") && (simObj?.hasOwnProperty("version") && simObj?.version > 1)){
  //     if(isUserInput.current){
  //       if(window.$(".ui.dimmer .user-input").length > 0){
  //         focusPopUp(".user-input");
  //         document.querySelector(".user-input input").removeAttribute("tabindex");
  //         document.querySelector(".user-input input").focus();
  //         document.querySelectorAll(".user-input button").forEach((item)=>{
  //             item.removeAttribute("tabindex")
  //         });
  //       }
  //     }
  //   }
  // },[simObj,isUserInput.current])

  useEffect(()=>{
    if(simObj?.hasOwnProperty("userData") && (simObj?.hasOwnProperty("version") && simObj?.version > 1)){
        setTimeout(() => {
          if(simObj?.userData == ""){
            if(document.querySelector(".ui.pointing.label")){
              document.querySelectorAll(".ui.pointing.label button").forEach((item)=>{
                item.setAttribute("tabindex","-1");
              })
            }
          }
          else{
            if(document.querySelector(".ui.pointing.label")){
              document.querySelectorAll(".ui.pointing.label button").forEach((item)=>{
                item.removeAttribute("tabindex");
              })
              document.querySelector(".ui.pointing.label").setAttribute("tabindex","0");
              document.querySelector(".ui.pointing.label").focus();
            }
          }
        }, 100);
    }
  },[simObj?.userData])

  useEffect(() => {
    if((simObj?.hasOwnProperty("userData") && simObj?.userData == "") && (simObj?.hasOwnProperty("version") && simObj?.version > 1) && headerPopup){
      setIsModalVisible(true);
      window.$('.my-dimmer .ui.dimmer').dimmer({
        closable: false // Prevent closing when clicked
      }).dimmer('show');
      isUserInput.current = true;
    }
  }, [simObj, headerPopup]);

  useEffect(() => {
    if (isModalVisible) {
      if (document.querySelector('.custom-modal')) {
        focusPopUp(".custom-modal");
        document.querySelector(".custom-modal input").removeAttribute("tabindex");
          document.querySelector(".custom-modal input").focus();
          document.querySelectorAll(".custom-modal button").forEach((item)=>{
              item.removeAttribute("tabindex")
          });
      }
    }
  }, [isModalVisible]);

  useEffect(() => {
    const handleResize1 = ()=> {
          if(qmPopup?.kpiBox && document.querySelector(".ui.pointing.label") != null){
            let top = document.getElementsByClassName(`${QmModuleStyle['profit-loss']}`)[0].offsetTop + document.getElementsByClassName(`${QmModuleStyle['profit-loss']}`)[0].clientHeight;
            setQmKpiTop(top);
          }
          if((qmPopup?.availableCash || qmPopup?.utilizeBtn) && document.getElementsByClassName("ui pointing label")[0] != null){
            let top = document.getElementsByClassName(`${QmModuleStyle["activities"]}`)[0].clientHeight;
            if(qmPopup?.availableCash){
              setAvailCashTop(top);
            }
            if(qmPopup?.utilizeBtn){
              setUtilizeBtnTop(top);
            }
          }
          if(qmPopup?.utilizedInvest && document.getElementsByClassName("ui pointing label")[0] != null){
            let top = 0;
            if(document.getElementsByClassName(`${QmModuleStyle['make-decision-activity']}`)[0].offsetTop){
              top = document.getElementsByClassName(`${QmModuleStyle['sim-progress-activity']}`)[0].clientHeight - document.getElementsByClassName('ui pointing label')[0].clientHeight + 15 - Number(window.$('#makeDecisionActivity').css('margin-top').split("px")[0]);
              if(Number(window.$('#makeDecisionActivity').css('margin-top').split("px")[0]) == 0){
                top -= 30;
              }
            }else{
              top = -(document.getElementsByClassName('ui pointing label')[0].clientHeight) - Number(window.$(".ui.pointing.label").css("margin-top").split("px")[0]) - 20;
            }
            setUtilizedInvestTop(top);
          }
    }
    window.addEventListener('resize', handleResize1);
    handleResize1();
  }, [qmPopup?.availableCash, qmPopup?.utilizeBtn,qmPopup?.utilizedInvest, qmPopup?.kpiBox]);

   //Added for stylus tool
   useEffect(() => {
    const checkStyleTag = () => {
      const styleTag = document.querySelector('style.stylus');
      setIsStyleTagPresent(!!styleTag);  // Updates the state to true if the tag is found, false otherwise
    };
    checkStyleTag();
    // Optionally, if the tag might be dynamically added, use a MutationObserver or setInterval
    const intervalId = setInterval(checkStyleTag, 500); // Check every 500ms
    return () => clearInterval(intervalId);  // Clean up interval when component unmounts
  }, []);

  return (
    <motion.div className={`${QmModuleStyle.simulation} ${QmModuleStyle.container}`} id={`${isStyleTagPresent ? `${QmModuleStyle['qmStylus']}` : ''}`} initial={{ opacity: 0 }} animate={{ opacity: 1 }} transition={{ duration: 0.5 }}>
      <div className={`${QmModuleStyle.introtext}`}>
        <h2 className={`${QmModuleStyle.heading} ${QmModuleStyle.bgpurple} ${QmModuleStyle.imSim}`}>Simulation</h2>
        <p>All investment will be spread across 60 days from the date of investment. </p>
        {/* Click &nbsp;
        <Link to={`${rootRoute}/${simType?.toLowerCase()}?from=simulation`} style={{'color':'#000','text-decoration':'underline','font-weight':'bold'}}>
          <em className="info circle icon" aria-hidden="true" role="presentation"></em>
          <span>here</span>
        </Link>
        &nbsp;to revisit the tutorial.</p> */}
      </div>
      <hr aria-hidden="true" role="presentation" />
      <CalProfitLoss popupState={[simPopup, setSimPopup, isOverlay, setIsOverlay, headerPopup, setHeaderPopup, isArtifacts, setIsArtifacts, plPopup, setPlPopup, ulPopup, setUlPopup, simPrgPopup, setSimPrgPopup, skipWalkThruPopups, accordionPopup, setAccordionPopup, simObj, setSimObj, formatNum, toggleSimulation, qmPopup, setQmPopup,setRelaunchPopup]} />
      {
        qmPopup?.kpiBox ? <div className={`ui pointing label ${QmModuleStyle.ui} ${QmModuleStyle.pointing} ${QmModuleStyle.label} ${QmModuleStyle['kpi-popup']}`} role='dialog' aria-modal="true" aria-label="Key Performance Indicators popup" tabIndex={-1} style={{top:qmKpiTop+"px"}}>
            <p>Keep an eye on these Key Performance Indicators (KPIs) to know how well you're doing against your goal.</p>
            <div className={`${QmModuleStyle.mt10} ${QmModuleStyle.dflex}`}>
            <Button btnName="Skip Walk-Thru" btnWidth="130" clickEventHandler={skipWalkThruPopups} />
            <Button btnName="Next" btnParentClassName={`${QmModuleStyle.ml10}`} btnWidth="80" clickEventHandler={() => {
                setQmPopup((prevQmPopup) => ({...prevQmPopup, ['kpiBox'] : false }));
                setRelaunchPopup(true)
            }} />
            </div>
        </div> : ""
      }
      <hr aria-hidden="true" role="presentation" />
      <div className={`${QmModuleStyle['activities']}`}>


        <SimProgress actions={[playSimulation, resumeSimulation, pauseSimulation, toggleSimulation, setToggleSimulation,isShowPlaceOrder]} popupState={[simPopup, setSimPopup, isOverlay, setIsOverlay, headerPopup, setHeaderPopup, isArtifacts, setIsArtifacts, plPopup, setPlPopup, ulPopup, setUlPopup, simPrgPopup, setSimPrgPopup, skipWalkThruPopups, simObj, setSimObj, getMonth, isLoader, setIsLoader, setError, error, isRequestLoading,qmPopup,setQmPopup]} />
        {
          qmPopup?.utilizedInvest ? <div className={`ui pointing label ${QmModuleStyle.ui} ${QmModuleStyle.pointing} ${QmModuleStyle.label} ${QmModuleStyle["utilized-investment-popup"]}`} role='dialog' aria-modal="true" aria-label="Utilized investments popup" tabIndex={-1} style={{top:utilizedInvestTop+"px"}}>
            <p>At any time you can also see what you already invested in under Utilized Investments.</p>
            <div className={`${QmModuleStyle.mt10} ${QmModuleStyle.dflex}`}>
              <Button btnName="Skip Walk-Thru" btnWidth="130" clickEventHandler={skipWalkThruPopups} />
              <Button btnName="Next" btnParentClassName={`${QmModuleStyle.ml10}`} btnWidth="80" clickEventHandler={() => {
                setQmPopup((prevQmPopup) => ({...prevQmPopup, ['utilizedInvest'] : false, ['makeInvetsment'] : true}))
              }} />
            </div>
          </div> : ""
        }
        <div id='makeDecisionActivity' className={`${QmModuleStyle['make-decision-activity']} ${(qmPopup?.availableCash || qmPopup?.utilizedInvest || qmPopup?.utilizeBtn)   ? `show ${QmModuleStyle['show']}` : ''}`} style={{ minHeight: pOrderActivityHeight }}>
          <MakeDecisions pOrderActivityHeight={pOrderActivityHeight} setPOrderActivityHeight={setPOrderActivityHeight} simObj={simObj} setSimObj={setSimObj} formatNum={formatNum} setError={setError} toggleSimulation={toggleSimulation} setToggleSimulation={setToggleSimulation} isRequestLoading={isRequestLoading} getMonth={getMonth} skipWalkThruPopups ={skipWalkThruPopups} setIsShowPlaceOrder={setIsShowPlaceOrder} qmPopup = {qmPopup} setQmPopup={setQmPopup} setIsRequestLoading={setIsRequestLoading}/>
        </div>
        {
          qmPopup?.availableCash ? <div className={`ui pointing label ${QmModuleStyle.ui} ${QmModuleStyle.pointing} ${QmModuleStyle.label} ${QmModuleStyle['invest-popup']}`} role='dialog' aria-modal="true" aria-label="Available investments popup" tabIndex={-1} style={{top: availCashTop+"px"}}>
            <p>When you are ready, review possible investments under Available Investments and their costs here. You can only invest from your Available Cash.</p>
            <div className={`${QmModuleStyle.mt10} ${QmModuleStyle.dflex}`}>
              <Button btnName="Skip Walk-Thru" btnWidth="130" clickEventHandler={skipWalkThruPopups} />
              <Button btnName="Next" btnParentClassName={`${QmModuleStyle.ml10}`} btnWidth="80" clickEventHandler={()=>{
                 setQmPopup((prevQmPopup)=>({...prevQmPopup, ['availableCash'] : false, ['utilizeBtn']: true }))
                   document.querySelector("#panelList").scrollTo(250,0);
              }} />   
            </div>
          </div> : ''
        }

        {
          qmPopup?.utilizeBtn ? <div className={`ui pointing label ${QmModuleStyle.ui} ${QmModuleStyle.pointing} ${QmModuleStyle.label} ${QmModuleStyle['utilize-btn-popup']}`} role='dialog' aria-modal="true" aria-label="Utilize button popup" tabIndex={-1} style={{top:utilizeBtnTop+"px"}}>
            <p>Add a check to the investments you want to make and click Utilize to confirm them.</p>
            <div className={`${QmModuleStyle.mt10} ${QmModuleStyle.dflex}`}>
              <Button btnName="Skip Walk-Thru" btnWidth="130" clickEventHandler={skipWalkThruPopups} />
              <Button btnName="Next" btnParentClassName={`${QmModuleStyle.ml10}`} btnWidth="80" clickEventHandler={()=>{
                 setQmPopup((prevQmPopup)=>({...prevQmPopup, ['utilizeBtn'] : false, ['utilizedInvest']: true }));
                 window.$("html, body").animate({ scrollTop: 0, }, 100);
              }} />   
            </div>
          </div> : ''
        }
      </div>
      {/* <div className={`${QmModuleStyle['simmsg-container']}`}>
        {
          (
            ((toggleSimulation && simObj.status != 'COMPLETED' && simObj?.laststate?.investmentOptions?.QMInvestmentOptions?.length!=0) && !isShowPlaceOrder)
             || (!(toggleSimulation && simObj.status != 'COMPLETED' && simObj?.laststate?.investmentOptions?.QMInvestmentOptions?.length!=0) && isShowPlaceOrder) 
             || (simObj?.laststate?.investmentOptions?.QMInvestmentOptions?.length > 0 && simObj?.laststate?.investmentOptions?.isUpcomming)
             || (!(toggleSimulation && simObj.status != 'COMPLETED' && simObj?.laststate?.investmentOptions?.QMInvestmentOptions?.length!=0) && !isShowPlaceOrder && (simObj.status == 'COMPLETED'))) && <div className={`ui success message ${QmModuleStyle.ui} ${QmModuleStyle.success} ${QmModuleStyle.message} ${QmModuleStyle.simmsg}`}>
            <div role='alert'>
              { simObj.currentstep != 0 && <img src={info} />}
              { 
                (toggleSimulation && simObj.status != 'COMPLETED' && simObj?.laststate?.investmentOptions?.QMInvestmentOptions?.length!=0) && <p>{`Pause the simulation to make a new decision.`}</p>
              }
              {
                !(toggleSimulation) && (isShowPlaceOrder) && <p className='placeorder-msg'>{`Your investment decisions are saved, please click on ${simObj?.currentstep > 0 ? 'Resume' : 'Start'} Simulation to continue.`}</p>
              }
              {                
                (simObj.status != 'COMPLETED') &&  simObj.currentstep != 0 && (!(toggleSimulation) && !(isShowPlaceOrder) && simObj?.laststate?.investmentOptions?.QMInvestmentOptions?.length > 0 && simObj?.laststate?.investmentOptions?.isUpcomming) && <p>{`Please review and make investment decisions and click on Resume Simulation.`}</p>
              }
              {
                (simObj.status == 'COMPLETED') && <p>{`Simulation is completed! Please click on "Show Summary" to view report.`}</p>
              }
            </div>
          </div>
        }
      </div> */}
      <hr className={`${QmModuleStyle['mt0']}`} aria-hidden="true" role="presentation" />
      <div className={`${QmModuleStyle['graph-wrapper']}`}>
        <div className={`${QmModuleStyle['_graph']}`} id="CostQuality">
          <div className={`${QmModuleStyle['options']}`}>
            <h3 id="Rev-Cost">Revenue&nbsp;&nbsp;/&nbsp;&nbsp;Cost of Quality</h3>
            <div className={QmModuleStyle['action-buttons']}>
              <div className="tabs">
                <div role="tablist" aria-labelledby="Rev-Cost" className="Graphs">
                  <button
                    className={`month ui button ${QmModuleStyle['ui']} ${QmModuleStyle['button']} ${periodicalType === "monthly" ? QmModuleStyle['active'] : ''}`}
                    type="button"
                    role="tab"
                    onClick={funMonthlyHandler}
                    style={{
                      color: periodicalType === "monthly" ? "#B90000" : "black",
                      transition: "border-bottom 0.2s",
                      borderBottom: periodicalType === "monthly" ? "2px solid #B90000" : "",
                      padding: "4px 11px",
                      borderRadius: 0
                    }}
                    aria-selected={periodicalType === 'monthly'}
                    //tabindex={periodicalType === 'monthly' ? "0" : "-1"}
                    aria-controls="tabpanel-1"
                    id="tab-1"
                  >
                    Month
                  </button>
                  <button
                    className={`quarter ui button ${QmModuleStyle['ui']} ${QmModuleStyle['button']} ${periodicalType === "quarterly" ? QmModuleStyle['active'] : ''}`}
                    type="button"
                    role="tab"
                    onClick={funQuarterlyHandler}
                    style={{
                      color: periodicalType === "quarterly" ? "#B90000" : "black",
                      transition: "border-bottom 0.2s",
                      borderBottom: periodicalType === "quarterly" ? "2px solid #B90000" : "",
                      padding: "4px 11px",
                      borderRadius: 0
                    }}
                    aria-selected={periodicalType === 'quarterly'}
                    //tabindex={periodicalType === 'quarterly' ? "0" : "-1"}
                    aria-controls="tabpanel-2"
                    tabIndex="-1"
                    id="tab-2"
                  >
                    Quarter
                  </button>
                  <button
                    className={`year ui button ${QmModuleStyle['ui']} ${QmModuleStyle['button']} ${periodicalType === "yearly" ? QmModuleStyle['active'] : ''}`}
                    type="button"
                    role="tab"
                    onClick={funYearlyHandler}
                    style={{
                      color: periodicalType === "yearly" ? "#B90000" : "black",
                      transition: "border-bottom 0.2s",
                      borderBottom: periodicalType === "yearly" ? "2px solid #B90000" : "",
                      padding: "4px 11px",
                      borderRadius: 0
                    }}
                    aria-selected={periodicalType === 'yearly'}
                    //tabindex={periodicalType === 'yearly' ? "0" : "-1"}
                    tabIndex="-1"
                    aria-controls="tabpanel-3"
                    id="tab-3"
                  >
                    Year-to-Date
                  </button>
                  <a onClick={() => openNewWindow()} aria-hidden="true" tabIndex="-1" className="sr-only">Open a table version of graphdata</a>
                </div>
              </div>
            </div>
          </div>
          <RevenueGraph type={periodicalType} isDecisionPopup={isDecisionPopup} showDecisionPopupHandler={showDecisionPopup} hideDecisionPopupHandler={hideDecisionPopup} simObj={simObj} setSimObj={setSimObj} point={point} setPoint={setPoint} />
          {/*<div className={`${QmModuleStyle['Revenuegraph-legend']}`} aria-hidden="true">
            <div><span className={`${QmModuleStyle['pattern']} ${QmModuleStyle['revenue-legend']}`}>&#9632;</span><span>Revenue</span></div>
            <div>
              <span className={`${QmModuleStyle['pattern']} ${QmModuleStyle['cost-legend']}`}>&#9632;</span>
              <span>Cost of Quality</span></div></div>*/}
          <div className={`${QmModuleStyle['costquality-legends']}`}>
            <div className={`${QmModuleStyle['container-div']}`} aria-hidden="true">
              <div className={`${QmModuleStyle['circle-line']}`}></div>
              <div className={`${QmModuleStyle['horizontal-line-circle']}`}></div>  
            </div>
            <div>Revenue</div>
            <div className ={`${QmModuleStyle['container-div']}`} aria-hidden="true">
            <div className ={`${QmModuleStyle['horizontal-line-rhombus']}`}></div>
            <div className ={`${QmModuleStyle['rhombus']}`}></div>
            <div className ={`${QmModuleStyle['circle-rhombus']}`}></div>
            </div>
            <div>Cost of Quality</div>
          </div>
          {/* <div className={`${QmModuleStyle['inventorygraph-legend']}`} aria-hidden="true"><span className={`${QmModuleStyle['inventory-legend']} ${QmModuleStyle['inventorypattern']}`}>&#8226;</span>Inventory</div> */}
          {/* <InventoryGraph type={periodicalType} isDecisionPopup={isDecisionPopup} showDecisionPopupHandler={showDecisionPopup} hideDecisionPopupHandler={hideDecisionPopup} simObj={simObj} setSimObj={setSimObj} /> */}
        </div>
        <span className={`${QmModuleStyle['seprater']}`}></span>
        <div className={`${QmModuleStyle['_graph']}`} id="FailureRate">
          <div className={`${QmModuleStyle['options']}`}>
            <h3 id="FailRate">Failure Rate</h3>
            <div className={QmModuleStyle['action-buttons']}>
              <div className="tabs">
                <div role="tablist" aria-labelledby="FailRate" className="Graphs">
                  <button
                    className={`month ui button ${QmModuleStyle['ui']} ${QmModuleStyle['button']} ${periodicalTypeFailure === "monthly" ? QmModuleStyle['active'] : ''}`}
                    type="button"
                    role="tab"
                    onClick={funMonthlyHandlerFailure}
                    style={{
                      color: periodicalTypeFailure === "monthly" ? "#B90000" : "black",
                      transition: "border-bottom 0.2s",
                      borderBottom: periodicalTypeFailure === "monthly" ? "2px solid #B90000" : "",
                      padding: "4px 11px",
                      borderRadius: 0
                    }}
                    aria-selected={periodicalTypeFailure === 'monthly'}
                    //tabindex={periodicalType === 'monthly' ? "0" : "-1"}
                    aria-controls="tabpanel-4"
                    id="tab-4"
                  >
                    Month
                  </button>
                  <button
                    className={`quarter ui button ${QmModuleStyle['ui']} ${QmModuleStyle['button']} ${periodicalTypeFailure === "quarterly" ? QmModuleStyle['active'] : ''}`}
                    type="button"
                    role="tab"
                    onClick={funQuarterlyHandlerFailure}
                    style={{
                      color: periodicalTypeFailure === "quarterly" ? "#B90000" : "black",
                      transition: "border-bottom 0.2s",
                      borderBottom: periodicalTypeFailure === "quarterly" ? "2px solid #B90000" : "",
                      padding: "4px 11px",
                      borderRadius: 0
                    }}
                    aria-selected={periodicalTypeFailure === 'quarterly'}
                    //tabindex={periodicalType === 'quarterly' ? "0" : "-1"}
                    aria-controls="tabpanel-5"
                    tabIndex="-1"
                    id="tab-5"
                  >
                    Quarter
                  </button>
                  <button
                    className={`year ui button ${QmModuleStyle['ui']} ${QmModuleStyle['button']} ${periodicalTypeFailure === "yearly" ? QmModuleStyle['active'] : ''}`}
                    type="button"
                    role="tab"
                    onClick={funYearlyHandlerFailure}
                    style={{
                      color: periodicalTypeFailure === "yearly" ? "#B90000" : "black",
                      transition: "border-bottom 0.2s",
                      borderBottom: periodicalTypeFailure === "yearly" ? "2px solid #B90000" : "",
                      padding: "4px 11px",
                      borderRadius: 0
                    }}
                    aria-selected={periodicalTypeFailure === 'yearly'}
                    //tabindex={periodicalType === 'yearly' ? "0" : "-1"}
                    tabIndex="-1"
                    aria-controls="tabpanel-6"
                    id="tab-6"
                  >
                    Year-to-Date
                  </button>
                  <a onClick={() => openNewWindow()} aria-hidden="true" tabIndex="-1" className="sr-only">Open a table version of graphdata</a>
                </div>
              </div>
            </div>
            {/* <div className={`${QmModuleStyle['Revenuegraph-legend']}`} aria-hidden="true">
              <div><span className={`${QmModuleStyle['pattern']} ${QmModuleStyle['revenue-legend']}`}>&#8226;</span><span>Revenue</span></div>
              <div>
                <span className={`${QmModuleStyle['pattern']} ${QmModuleStyle['cost-legend']}`}>&#9670;</span>
                <span>Costs</span></div>

            </div> */}
          </div>
          {/* <RevenueGraph type={periodicalType} isDecisionPopup={isDecisionPopup} showDecisionPopupHandler={showDecisionPopup} hideDecisionPopupHandler={hideDecisionPopup} simObj={simObj} setSimObj={setSimObj} point={point} setPoint={setPoint} /> */}


          <InventoryGraph type={periodicalTypeFailure} isDecisionPopup={isDecisionPopup} showDecisionPopupHandler={showDecisionPopup} hideDecisionPopupHandler={hideDecisionPopup} simObj={simObj} setSimObj={setSimObj} />

          <div className={`${QmModuleStyle['inventorygraph-legend']}`}><span className={`${QmModuleStyle['inventory-legend']} ${QmModuleStyle['inventorypattern']}`} aria-hidden="true">&#9632;</span>Failure Rate</div>
        </div>
      </div>
      {/* <div role={"dialog"} className={`ui tiny modal user-input ${QmModuleStyle["ui"]} ${QmModuleStyle["tiny"]} ${QmModuleStyle["modal"]} ${QmModuleStyle["user-input"]}`}>
        <table className={`ui unstackable table ${QmModuleStyle["ui"]} ${QmModuleStyle["unstackable"]} ${QmModuleStyle["table"]}`} role='presentation'>
            <tbody>
              <tr>
                <td className={`${QmModuleStyle["label"]}`} aria-hidden="true"> <label htmlFor='userData' id="userDataLabel">Name Your Restaurant</label></td>
                <td>
                  <div className={`ui input left aligned`}>
                    <input type="text" placeholder="Cibare" id="userData" className="user-data-input" autoComplete='off' aria-labelledby="userDataLabel"/>
                  </div>
                </td>
              </tr>
              
              <tr>
                <td></td>
                <td className={`actions left aligned ${QmModuleStyle["actions"]}`}>
                  <Button btnName={"Skip"} btnClass={`btn_cancel ${QmModuleStyle["btn_cancel"]}`}/>
                  <Button btnName={"Save"} btnClass={`btn_approve ${QmModuleStyle["btn_approve"]}`}/>
                </td>
              </tr>
              {
                (userDataInfo && userDataInfo?.valid==0) && 
                <tr style={inValidInputStyle}>
                  <td></td>
                  <td>{userDataInfo?.message}</td>
                </tr>
              }
          </tbody>
        </table>
      </div> */}

      {isModalVisible && (
        <>
          <div role={"dialog"} className={`custom-modal ${QmModuleStyle["custom-modal"]}`} aria-labelledby="userDataLabel">
          <table className={`custom-table ${QmModuleStyle["custom-table"]}`} role='presentation'>
              <tbody>
                <tr>
                  <td className={`${QmModuleStyle["label"]}`} aria-hidden="true"> 
                    <label htmlFor='userData' id="userDataLabel">Name Your Restaurant</label>
                  </td>
                  <td>
                    <div className={`custom-input ${QmModuleStyle["custom-input"]}`}>
                      <input type="text" placeholder="Cibare" id="userData" className="user-data-input" autoComplete='off' aria-labelledby="userDataLabel" value={inputValue} onChange={(e) => setInputValue(e.target.value)} />
                    </div>
                  </td>
                </tr>
                <tr>
                  <td></td>
                  <td className={`actions left aligned ${QmModuleStyle["actions"]}`}>
                    <Button btnName={"Skip"} btnClass={`btn_cancel ${QmModuleStyle["btn_cancel"]}`}/>
                    <Button btnName={"Save"} btnClass={`btn_approve ${QmModuleStyle["btn_approve"]}`}/>
                  </td>
                </tr>
                {
                  (userDataInfo && userDataInfo?.valid==0) && 
                  <tr style={inValidInputStyle}>
                    <td></td>
                    <td>{userDataInfo?.message}</td>
                  </tr>
                }
            </tbody>
          </table>
          </div>
        </>
      )}
    </motion.div>

  )
}

export default Simulation